import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox, Divider, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import InfoIcon from '@material-ui/icons/Info'
import { SelectComposto } from 'components/SelectComposto/SelectComposto'
import { ModalConfirmacao } from 'components/ModalConfirmacao'
import { SvgFront } from './components/SvgFront'
import { SvgBack } from './components/SvgBack'
import { SvgLeft } from './components/SvgLeft'
import { SvgRight } from './components/SvgRight'
import { useMapaCorpo } from './hooks/useMapaCorpo'
import { useStyles, DarkTooltip } from './MapaCorpo.styles'

export const MapaCorpo = (props) => {
  const { odonto, paraCicatriz } = props
  const classes = useStyles()

  const {
    renderSelectOption,
    formNovaLesao,
    options,
    handleClosePopoverLesao,
    handleSelectLesao,
    handleClickSvg,
  } = useMapaCorpo(props)

  const isFormDisabled = !formNovaLesao.formState.values.tipo || (odonto && !formNovaLesao.formState.values.descricao)

  return (
    <div id="div_mapa_corpo">
      <div style={{ width: '100%' }}>
        <ModalConfirmacao
          aberto={renderSelectOption}
          onClose={handleClosePopoverLesao}
          onConfirm={handleSelectLesao}
          titulo={paraCicatriz ? "Adicionar Tatuagem ou Cicatriz" : "Adicionar Lesão"}
          confirmarLabel="Confirmar"
          cancelarLabel="Cancelar"
          confirmarColor="secondary"
          disabled={isFormDisabled}
          maxWidth="sm"
          fullWidth
        >
          <Grid container spacing={2} style={{ padding: '10px' }}>
            <Grid item xs={12}>

              {paraCicatriz ? (
                <Grid container className={classes.fieldGroup}>
                  <Grid item xs={12} className={classes.field}>
                    <Autocomplete
                      name="tipo"
                      value={formNovaLesao.formState.values.tipo || null}
                      noOptionsText="Sem informações"
                      options={['CICATRIZ', 'TATUAGEM', 'MANCHA', 'OUTRO']}
                      onChange={(event, newValue) => formNovaLesao.handleChangeNewValueByNameProperty(event, newValue, 'tipo')}
                      required
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Tatuagem ou cicatriz"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.field}>
                    <TextField
                      value={formNovaLesao.formState.values.descricao || null}
                      variant="outlined"
                      fullWidth
                      label="Descrição"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={formNovaLesao.handleChange}
                      name="descricao"
                    />
                  </Grid>
                </Grid>
              ) : (
                <SelectComposto
                  md={12}
                  sm={12}
                  mt={12}
                  formState={formNovaLesao.formState}
                  nomePropriedadeSelect="tipo"
                  nomePropriedadeInputText="tipoTextoLivre"
                  options={options.tiposLesoes || []}
                  handleChangeOption={formNovaLesao.handleChangeNewValueByNameProperty}
                  handleChangeInputText={formNovaLesao.handleChange}
                  labelSelect="Tipo da lesão"
                />
              )}
            </Grid>

            {formNovaLesao.formState.values.tipo?.categoria === 'TIRO' && (
              <Grid item container className={classes.caracteristicasLesao}>
                <Grid item xs={12}>
                  <Typography>
                    <b>Características</b>
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.pafHaloEnxugo || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="pafHaloEnxugo" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Halo de enxugo</Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.pafAureolaEquimotica || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="pafAureolaEquimotica" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Auréola equimótica</Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.pafOrlaEscoriacao || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="pafOrlaEscoriacao" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Orla de escoriação</Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.pafZonaTatuagem || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="pafZonaTatuagem" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Zona de tatuagem</Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.pafZonaEsfumacamento || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="pafZonaEsfumacamento" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Zona de esfumaçamento</Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.pafZonaQueimadura || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="pafZonaQueimadura" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Zona de queimadura</Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.pafAspectoEstrelado || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="pafAspectoEstrelado" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Aspecto estrelado</Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.pafMarcaCano || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="pafMarcaCano" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Marca do cano</Typography>
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <Typography>
                        <b>Tipo de borda</b>
                      </Typography>
                      <Divider />
                    </FormLabel>
                    <RadioGroup row aria-label="gender" name="pafTipoBorda" value={formNovaLesao.formState.values.pafTipoBorda} onChange={formNovaLesao.handleChange}>
                      <FormControlLabel value="INVERTIDA" control={<Radio />} label="Invertida" />
                      <FormControlLabel value="INVERTIDA IRREGULAR" control={<Radio />} label="Invertida irregular" />
                      <FormControlLabel value="EVERTIDA" control={<Radio />} label="Evertida" />
                      <FormControlLabel value="EVERTIDA IRREGULAR" control={<Radio />} label="Evertida irregular" />
                      <FormControlLabel value="NÃO DEFINIDO" control={<Radio />} label="Não definido" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            )}

            {formNovaLesao.formState.values.tipo?.cod === 'INCISA' && (
              <Grid item container className={classes.caracteristicasLesao}>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <Typography>
                        <b>Região mais aprofundada</b>
                      </Typography>
                      <Divider />
                    </FormLabel>
                    <RadioGroup row aria-label="gender" name="incisaoRegiaoMaisAprofundada" value={formNovaLesao.formState.values.incisaoRegiaoMaisAprofundada} onChange={formNovaLesao.handleChange}>
                      <FormControlLabel value="À ESQUERDA" control={<Radio />} label="À esquerda" />
                      <FormControlLabel value="À DIREITA" control={<Radio />} label="À direita" />
                      <FormControlLabel value="ACIMA" control={<Radio />} label="Acima" />
                      <FormControlLabel value="ABAIXO" control={<Radio />} label="Abaixo" />
                      <FormControlLabel value="NÃO DEFINIDO" control={<Radio />} label="Não definido" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <Typography>
                        <b>Região com cauda de escoriação</b>
                      </Typography>
                      <Divider />
                    </FormLabel>
                    <RadioGroup row aria-label="gender" name="incisaoRegiaoCaudaEscoriacao" value={formNovaLesao.formState.values.incisaoRegiaoCaudaEscoriacao} onChange={formNovaLesao.handleChange}>
                      <FormControlLabel value="À ESQUERDA" control={<Radio />} label="À esquerda" />
                      <FormControlLabel value="À DIREITA" control={<Radio />} label="À direita" />
                      <FormControlLabel value="ACIMA" control={<Radio />} label="Acima" />
                      <FormControlLabel value="ABAIXO" control={<Radio />} label="Abaixo" />
                      <FormControlLabel value="NÃO DEFINIDO" control={<Radio />} label="Não definido" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <Typography>
                        <b>Borda</b>
                      </Typography>
                      <Divider />
                    </FormLabel>
                    <RadioGroup row aria-label="gender" name="incisaoBorda" value={formNovaLesao.formState.values.incisaoBorda} onChange={formNovaLesao.handleChange}>
                      <FormControlLabel value="RETRAÍDA" control={<Radio />} label="Retraída" />
                      <FormControlLabel value="NÃO RETRAÍDA" control={<Radio />} label="Não retraída" />
                      <FormControlLabel value="NÃO DEFINIDO" control={<Radio />} label="Não definido" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            )}

            {formNovaLesao.formState.values.tipo?.cod === 'PERFUROINCISA' && (
              <Grid item container className={classes.caracteristicasLesao}>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <Typography>
                        <b>Borda</b>
                      </Typography>
                      <Divider />
                    </FormLabel>
                    <RadioGroup row aria-label="gender" name="incisaoBorda" value={formNovaLesao.formState.values.incisaoBorda} onChange={formNovaLesao.handleChange}>
                      <FormControlLabel value="RETRAÍDA" control={<Radio />} label="Retraída" />
                      <FormControlLabel value="NÃO RETRAÍDA" control={<Radio />} label="Não retraída" />
                      <FormControlLabel value="NÃO DEFINIDO" control={<Radio />} label="Não definido" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <Typography>
                        <b>Forma</b>
                      </Typography>
                      <Divider />
                    </FormLabel>
                    <RadioGroup row aria-label="gender" name="perfuroIncisaForma" value={formNovaLesao.formState.values.perfuroIncisaForma} onChange={formNovaLesao.handleChange}>
                      <FormControlLabel value="BOTEIRA" control={<Radio />} label="Boteira" />
                      <FormControlLabel value="BICONVEXA" control={<Radio />} label="Biconvexa" />
                      <FormControlLabel value="NÃO DEFINIDO" control={<Radio />} label="Não definido" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            )}

            {formNovaLesao.formState.values.tipo?.cod === 'QUEIMADURA_ELETRICA' && (
              <Grid item container className={classes.caracteristicasLesao}>
                <Grid item xs={12}>
                  <Typography>
                    <b>Características</b>
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.metalizacao || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="metalizacao" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Metalização</Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.eritema || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="eritema" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Eritema</Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.flictema || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="flictema" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Flictema</Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.carbonizacao || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="carbonizacao" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Carbonização</Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.necrose || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="necrose" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Necrose</Typography>
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <Typography>
                        <b>Tipo de queimadura</b>
                      </Typography>
                      <Divider />
                    </FormLabel>
                    <RadioGroup row aria-label="gender" name="tipoQueimaduraEletrica" value={formNovaLesao.formState.values.tipoQueimaduraEletrica} onChange={formNovaLesao.handleChange}>
                      <FormControlLabel value="TIPO AFRANTUOSO" control={<Radio />} label="Tipo Afrantuoso" />
                      <FormControlLabel value="TIPO CAVITÁRIO" control={<Radio />} label="Tipo cavitário" />
                      <FormControlLabel value="TIPO POROSO" control={<Radio />} label="Tipo poroso" />
                      <FormControlLabel value="NÃO DEFINIDO" control={<Radio />} label="Não definido" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            )}

            {formNovaLesao.formState.values.tipo?.cod === 'COGUMELO_ESPUMA' && (
              <Grid item container className={classes.caracteristicasLesao}>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <Typography>
                        <b>Tipo</b>
                      </Typography>
                      <Divider />
                    </FormLabel>
                    <RadioGroup row aria-label="gender" name="tipoCogumeloEspuma" value={formNovaLesao.formState.values.tipoCogumeloEspuma} onChange={formNovaLesao.handleChange}>
                      <FormControlLabel value="SANGUINOLENTO" control={<Radio />} label="Sanguinolento" />
                      <FormControlLabel value="NÃO SANGUINOLENTO" control={<Radio />} label="Não sanguinolento" />
                      <FormControlLabel value="NÃO DEFINIDO" control={<Radio />} label="Não definido" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            )}

            {formNovaLesao.formState.values.tipo?.cod === 'SULCO' && (
              <Grid item container className={classes.caracteristicasLesao}>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <Typography>
                        <b>Orientação</b>
                      </Typography>
                      <Divider />
                    </FormLabel>
                    <RadioGroup row aria-label="gender" name="sulcoOrientacao" value={formNovaLesao.formState.values.sulcoOrientacao} onChange={formNovaLesao.handleChange}>
                      <FormControlLabel value="OBLÍQUO ASCENDENTE" control={<Radio />} label="Oblíquo Ascendente" />
                      <FormControlLabel value="HORIZONTALIZADO" control={<Radio />} label="Horizontalizado" />
                      <FormControlLabel value="NÃO DEFINIDO" control={<Radio />} label="Não definido" />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <Typography>
                        <b>Multiplicidade</b>
                      </Typography>
                      <Divider />
                    </FormLabel>
                    <RadioGroup row aria-label="gender" name="sulcoMultiplicidade" value={formNovaLesao.formState.values.sulcoMultiplicidade} onChange={formNovaLesao.handleChange}>
                      <FormControlLabel value="ÚNICO" control={<Radio />} label="Único" />
                      <FormControlLabel value="DUPLO" control={<Radio />} label="Duplo" />
                      <FormControlLabel value="TRIPLO" control={<Radio />} label="Triplo" />
                      <FormControlLabel value="MÚLTIPLO" control={<Radio />} label="Múltiplo" />
                      <FormControlLabel value="NÃO DEFINIDO" control={<Radio />} label="Não definido" />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <Typography>
                        <b>Continuidade</b>
                      </Typography>
                      <Divider />
                    </FormLabel>
                    <RadioGroup row aria-label="gender" name="sulcoContinuidade" value={formNovaLesao.formState.values.sulcoContinuidade} onChange={formNovaLesao.handleChange}>
                      <FormControlLabel value="CONTÍNUO" control={<Radio />} label="Contínuo" />
                      <FormControlLabel value="DESCONTÍNUO" control={<Radio />} label="Descontínuo" />
                      <FormControlLabel value="NÃO DEFINIDO" control={<Radio />} label="Não definido" />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <Typography>
                        <b>Tonalidade</b>
                      </Typography>
                      <Divider />
                    </FormLabel>
                    <RadioGroup row aria-label="gender" name="sulcoTonalidade" value={formNovaLesao.formState.values.sulcoTonalidade} onChange={formNovaLesao.handleChange}>
                      <FormControlLabel value="VIOLÁCEO" control={<Radio />} label="Violáceo" />
                      <FormControlLabel value="PÁLIDO" control={<Radio />} label="Pálido" />
                      <FormControlLabel value="AZULADO" control={<Radio />} label="Azulado" />
                      <FormControlLabel value="PARDO ESCURO" control={<Radio />} label="Pardo escuro" />
                      <FormControlLabel value="NÃO DEFINIDO" control={<Radio />} label="Não definido" />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <Typography>
                        <b>Profundidade</b>
                      </Typography>
                      <Divider />
                    </FormLabel>
                    <RadioGroup row aria-label="gender" name="sulcoProfundidade" value={formNovaLesao.formState.values.sulcoProfundidade} onChange={formNovaLesao.handleChange}>
                      <FormControlLabel value="UNIFORME" control={<Radio />} label="Uniforme" />
                      <FormControlLabel value="DESIGUAL" control={<Radio />} label="Desigual" />
                      <FormControlLabel value="NÃO DEFINIDO" control={<Radio />} label="Não definido" />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <Typography>
                    <b>Outras Características</b>
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.sulcoTumefeito || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="sulcoTumefeito" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Tumefeito</Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.sulcoMargensElevadas || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="sulcoMargensElevadas" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Margens elevadas</Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.sulcoLeitoDeprimido || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="sulcoLeitoDeprimido" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Leito deprimido</Typography>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Checkbox checked={formNovaLesao.formState.values.sulcoPeleEnrugada || false} onChange={formNovaLesao.handleChange} inputProps={{ 'aria-label': 'controlled' }} name="sulcoPeleEnrugada" style={{ marginRight: '10px' }} />
                  <Typography display="inline">Pele enrugada</Typography>
                </Grid>
              </Grid>
            )}
          </Grid>
        </ModalConfirmacao>
      </div>

      <Grid container id="Teste" className={classes.svgWrapper}>
        <Grid container item md={6} sm={6} xs={12} alignContent="center" alignItems="center" justifyContent="center" className={classes.gridItemFront}>
          <Grid item xs={12} alignContent="center" alignItems="center">
            <SvgFront odonto={odonto} handleClickSvg={handleClickSvg} />
          </Grid>
        </Grid>
        <Grid container item md={6} sm={6} xs={12} alignContent="center" alignItems="center" justifyContent="center" className={classes.gridItemBack}>
          <Grid item xs={12} alignContent="center" alignItems="center">
            <SvgBack odonto={odonto} handleClickSvg={handleClickSvg} />
          </Grid>
        </Grid>
        <Grid container item md={6} sm={6} xs={12} alignContent="center" alignItems="center" justifyContent="center" className={classes.gridItemLeft}>
          <Grid item xs={12} alignContent="center" alignItems="center">
            <SvgLeft odonto={odonto} handleClickSvg={handleClickSvg} />
          </Grid>
        </Grid>
        <Grid container item md={6} sm={6} xs={12} alignContent="center" alignItems="center" justifyContent="center" className={classes.gridItemRight}>
          <Grid item xs={12} alignContent="center" alignItems="center">
            <SvgRight odonto={odonto} handleClickSvg={handleClickSvg} />
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

MapaCorpo.propTypes = {
  lesoes: PropTypes.array.isRequired,
  setLesoes: PropTypes.func.isRequired,
  paraCicatriz: PropTypes.bool,
  setSVGElements: PropTypes.func,
  odonto: PropTypes.bool,
}

MapaCorpo.defaultProps = {
  paraCicatriz: false,
  setSVGElements: null,
  odonto: false,
}
